import { createReducer, createSelector } from '@reduxjs/toolkit';
import { NOTIFICATIONCONTENTTYPE_INCLUDE } from '../../constants/api';
import { API_REDUCER } from '../../constants/store';
import { getNotificationContentSpecificationForHearingSuccess } from '../actions/api';
import { updateDtoList } from '../helpers/reducerHelpers';
import {
  getIncludedData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';

// -------- Overview --------

// NotificationContentType is included in the following endpoints
//  - GET /hearing/{hearingId}/notificationContentSpecification

// -------- Reducer --------
const notificationContentTypeReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder.addCase(
      getNotificationContentSpecificationForHearingSuccess,
      (state, action) => {
        const data = getIncludedData(action);
        const notificationContentTypes = data.filter(
          (include) => include.type === NOTIFICATIONCONTENTTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', notificationContentTypes);
      },
    );
  },
);

// -------- Selectors --------
const selectAllNotificationContentTypes = (state) =>
  selectAllFromApiState(state, API_REDUCER.NOTIFICATION_CONTENT_TYPE);

const allNotificationContentTypesSelector = createSelector(
  selectAllNotificationContentTypes,
  (notificationContentTypes) => notificationContentTypes,
);

export { allNotificationContentTypesSelector };
export default notificationContentTypeReducer;
